export const NoTokenPaths = [
  '/api/v0/auth/login',
  '/api/v0/auth/authenticate',
  '/api/v0/auth/refresh',
] as const;
